import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  itemContainer: theme => ({
    flexDirection: 'row',
    minHeight: 44,
    height: 63,
    borderBottomWidth: 1,
    borderColor: theme.colors.VFDivider.tertiary,
  }),
  leftElementContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 2,
  },
  rightSectionContainer: {
    marginLeft: 18,
    flexDirection: 'row',
    flex: 20,
  },
  mainTitleContainer: {
    justifyContent: 'center',
    flexDirection: 'column',
    flex: 1,
  },
  rightElementContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 0.4,
  },
  rightTextContainer: {
    justifyContent: 'center',
    marginRight: 10,
  },
  titleStyle: theme => ({
    fontSize: 16.6,
    lineHeight: 22.9,
    textTransform: 'capitalize',
    color: theme.colors.headerTitleColor,
  }),
  descriptionStyle: theme => ({
    fontSize: 14.6,
    lineHeight: 18.7,
    color: theme.colors.textColorTwo,
  }),
});
